export default __webpack_public_path__ + "static/media/1.41ca31a2.jpg";